export const services = [
  {
    num: "01",
    slug: "brand-strategy",
    name: "Brand Strategy",
    desc: "We create distinct positioning, iconic visual identities, and persuasive verbal architectures that command instant market authority and long-term customer devotion.",
    chips: ["Positioning", "Identity Design", "Market Research", "Messaging", "Brand Guidelines", "Rebranding", "Competitor Audit", "Buyer Personas"],
    image: "/assets/svc-brand.png",
    heroImage: "/assets/svc-brand.png",
    deliverables: [
      { title: "Market Intelligence & Positioning", desc: "Deep competitive auditing, category gap analysis, and strategic positioning frameworks that carve out your exclusive market space." },
      { title: "Visual Identity & Logo Systems", desc: "Primary logo lockups, custom brand marks, color palettes, typography, and complete visual assets that command immediate prestige." },
      { title: "Brand Messaging & Voice", desc: "Core messaging pillars, value propositions, tone-of-voice playbooks, and taglines that articulate your worth with supreme clarity." },
      { title: "Brand Guidelines & Governance", desc: "Complete corporate brand books defining clear-space rules, digital standards, and asset usage to maintain absolute global consistency." },
      { title: "Pitch Decks & Sales Collateral", desc: "High-stakes investor decks, sales presentation templates, and narrative collateral engineered to win enterprise trust and close funding." },
      { title: "Brand Architecture & Naming", desc: "Product naming frameworks, sub-brand structures, and portfolio organization built for seamless long-term scaling." },
    ],
  },
  {
    num: "02",
    slug: "content-creation",
    name: "Content Creation",
    desc: "We produce high-impact videos, write compelling copy, and design visuals that bring your brand's story to life across every digital channel.",
    chips: ["Video Production", "Copywriting", "Ad Creatives", "Case Studies", "Visual Design", "Marketing Collateral", "Scriptwriting", "Product Shoots"],
    image: "/assets/svc-content.png",
    heroImage: "/assets/svc-content.png",
    deliverables: [
      { title: "Short-Form Video Production", desc: "High-converting Reels, TikToks, and Shorts scripted, shot, and edited to capture attention and maximize viral retention." },
      { title: "Brand Photography & Shoots", desc: "Professional product photography, founder portraits, and lifestyle visual assets engineered for multi-channel deployment." },
      { title: "Copywriting & Storytelling", desc: "Conversion-focused landing page copy, long-form editorial content, ad copy, and campaign scripts that turn readers into buyers." },
      { title: "Ad Creative Production", desc: "High-performing static banners, dynamic motion graphics, and video variations built specifically for paid media testing." },
      { title: "Social Media Graphics", desc: "Platform-native carousels, custom infographics, and branded templates built for daily distribution and high engagement." },
      { title: "Content Playbooks & Guidelines", desc: "Monthly content calendars, asset distribution frameworks, and brand asset libraries designed for seamless asset management." },
    ],
  },
  {
    num: "03",
    slug: "digital-presence-seo",
    name: "Digital Presence & SEO",
    desc: "We build high-speed web platforms and AI-era search strategies that convert traffic and capture category market share across Google and LLMs.",
    chips: ["Web Development", "Technical SEO", "UI/UX Design", "Landing Pages", "CRO", "AEO Strategy", "Site Audits", "Link Building"],
    image: "/assets/svc-seo.png",
    heroImage: "/assets/svc-seo.png",
    deliverables: [
      { title: "High-Converting Web Platforms", desc: "Custom web experiences built with modern UI/UX, psychological entry points, and seamless paths to purchase." },
      { title: "Campaign Landing Pages", desc: "Precision landing pages built for paid media, maximizing conversion rates and lowering your customer acquisition costs." },
      { title: "E-Commerce & Shopify Development", desc: "High-velocity online storefronts optimized for instant load times, dynamic upsells, and friction-free checkouts." },
      { title: "Technical SEO & Site Structure", desc: "Clean code foundations, sub-second speed optimizations, and crawl frameworks that guarantee search engine priority." },
      { title: "AI & Generative Search (GEO / AEO)", desc: "Strategic content optimization ensuring your brand appears as the trusted answer across ChatGPT, Gemini, and Perplexity." },
      { title: "Analytics & Conversion Tracking", desc: "Server-side tracking, GA4 event setups, and custom attribution dashboards mapped directly to your primary revenue metrics." },
    ],
  },
  {
    num: "04",
    slug: "pr-social-media",
    name: "PR & Social Media",
    desc: "We secure top-tier press coverage and manage your social channels to build lasting market authority, engage your target audience, and keep your brand in the spotlight.",
    chips: ["Media Relations", "Organic Social", "Press Releases", "Thought Leadership", "Executive Comms", "Community", "Influencers", "B2B Social"],
    image: "/assets/svc-pr.png",
    heroImage: "/assets/svc-pr.png",
    deliverables: [
      { title: "Top-Tier Press & Media Placement", desc: "Strategic press distribution, editorial pitching, and high-authority media features that establish instant industry credibility." },
      { title: "Executive Branding & Thought Leadership", desc: "Positioning founders and key leaders as industry authorities through curated commentary, guest articles, and podcast opportunities." },
      { title: "Full-Funnel Social Channel Management", desc: "End-to-end management of your primary social platforms, maintaining a consistent publishing cadence and distinct brand voice." },
      { title: "Audience Engagement & Community Growth", desc: "Active daily interactions, comment management, and targeted outreach that turn passive followers into loyal brand advocates." },
      { title: "Reputation & Crisis Management", desc: "Proactive communication playbooks and rapid-response frameworks designed to protect your public perception and brand trust." },
      { title: "Digital PR & Authority Building", desc: "High-value media mentions, digital editorial features, and high-DA backlinks that elevate both search presence and market standing." },
    ],
  },
  {
    num: "05",
    slug: "performance-marketing",
    name: "Performance Marketing",
    desc: "We deploy high-converting paid media campaigns across search and social channels that maximize spend efficiency and predictably scale your pipeline and revenue.",
    chips: ["Paid Search", "Paid Social", "Google Ads", "Meta Ads", "LinkedIn Ads", "Retargeting", "Media Buying", "A/B Testing", "Analytics Tracking"],
    image: "/assets/svc-performance.png",
    heroImage: "/assets/svc-performance.png",
    deliverables: [
      { title: "Meta Ads Strategy & Management", desc: "High-performing Facebook and Instagram ad campaigns structured for systematic audience testing, retargeting, and profitable scale." },
      { title: "Google Search & Shopping Ads", desc: "Precision Search, Shopping, and Performance Max campaign setups designed to capture active, high-intent customer queries." },
      { title: "LinkedIn B2B Paid Campaigns", desc: "Targeted account-based marketing and decision-maker campaigns engineered to drive qualified pipeline leads and high-value deals." },
      { title: "Creative Testing & Iteration", desc: "Systematic testing of ad hooks, visual formats, and messaging variations to constantly lower your customer acquisition costs." },
      { title: "Funnel & Offer Optimization", desc: "Continuous landing page alignment, entry-offer tweaks, and checkout friction reduction to maximize returns on ad spend." },
      { title: "Server-Side Tracking & Attribution", desc: "Precision GA4, CAPI, and custom tracking setups providing clear, transparent revenue data for every ad dollar spent." },
    ],
  },
  {
    num: "06",
    slug: "ecommerce-growth",
    name: "E-Commerce Growth",
    desc: "We optimize your online store, elevate customer lifetime value, and run targeted multi-channel campaigns that scale your sales across borders.",
    chips: ["Store Optimization", "Retention", "Cart Recovery", "Cross-Border", "Email & SMS", "Shopify Dev", "Sales Funnels", "Catalog Setup"],
    image: "/assets/svc-ecom.png",
    heroImage: "/assets/svc-ecom.png",
    deliverables: [
      { title: "High-Converting Storefront Optimization", desc: "Streamlined store layouts, mobile UX enhancements, and checkout refinements that reduce cart abandonment and boost conversion rates." },
      { title: "Multi-Channel Paid Acquisition", desc: "Data-driven acquisition setups across Meta, Google Shopping, and TikTok built for capital efficiency and net profit growth." },
      { title: "Automated Lifecycle Marketing", desc: "High-converting email and SMS flows covering abandoned cart recovery, post-purchase nurture, and customer retention series." },
      { title: "Average Order Value Boosts", desc: "Strategic in-cart upsells, product bundling systems, and tier-based offer structures designed to increase basket size." },
      { title: "Customer Retention & Loyalty Programs", desc: "Re-engagement campaigns, VIP reward systems, and subscription setups that maximize customer lifetime value." },
      { title: "Cross-Border Scaling & Localization", desc: "Multi-currency storefront setups, localized ad messaging, and international targeting playbooks for smooth market expansion." },
    ],
  },
];

export const rules = [
  {
    icon: "focus",
    title: ["Strategy", "before output"],
    body: "We don't create random assets to look busy. Every page, campaign, and pitch starts with a clear reason: who it's for, what it should say, and what action it should drive.",
  },
  {
    icon: "share",
    title: ["One message", "across channels"],
    body: "Your brand should not sound different on your website, social, search, email, and press. We align the message first, then build every channel around the same positioning and growth goal.",
  },
  {
    icon: "layers",
    title: ["Built for", "business impact"],
    body: "We don't measure success by completing a task list. We measure it by what happens after launch. Every piece of work is delivered fully integrated, tested, and aligned with your business goals.",
  },
];

export const testimonials = [
  {
    quote: "Most agencies just talk. This team actually builds. They fixed our site, sorted out our content, and got our ads performing. Our revenue numbers speak for themselves. Highly recommended.",
    name: "Harshal Gundey",
    role: "CEO of Vumez",
  },
  {
    quote: "They gave us absolute clarity. We connected to just build a fast website. But they set up our SEO strategy that has helped us improve our visibility. Besides the strategic marketing direction they provide has helped us allocate our resources more effectively.",
    name: "Manish Sharma",
    role: "CEO of Urban Eats",
  },
  {
    quote: "Working with them is incredibly refreshing. They streamlined our social media channels, and helped us scale smoothly. They deliver exactly what they promise.",
    name: "Seema",
    role: "VP of HMS",
  },
];

export const faqs = [
  {
    q: "What does our onboarding process look like, and how fast can we launch?",
    a: "Onboarding is completely frictionless. We deep-dive into your business goals on day one, align our teams, and deploy workflows to launch your first major campaigns within days, not months.",
  },
  {
    q: "How do you tailor strategies for brands looking to expand into completely new markets?",
    a: "We don't believe in copy-paste playbooks. We run deep consumer and competitive research to adapt your positioning, ensuring your message cuts through local noise and commands immediate trust.",
  },
  {
    q: "How do you keep our brand consistent across different channels and regions?",
    a: "We build airtight visual and narrative guidelines. Whether it is a high-impact video, a PR release, or a localized landing page, every asset passes through a strict performance filter to ensure your voice remains unmistakable.",
  },
  {
    q: "We have an established identity. Can you scale our presence without losing our core roots?",
    a: "Absolutely. We protect the DNA that made you successful in the first place. Our job is to amplify your core roots, giving your established identity a faster digital presence and a sharper edge to capture new market share.",
  },
];

export const contactInfo = {
  email: "ophodigital@opho.com",
  phone: "(406) 555-0120",
  address: "2972 Westheimer Rd. Santa Ana, Illinois 85486",
};

export const insightsCopy = {
  desc: "Turn complex business goals into clear marketing execution. Explore our key insights on messaging teardowns, performance strategies, and digital architectures designed for sustainable, long-term growth.",
};
